const steps = [
  {
    icon: "ri-upload-cloud-2-line",
    title: "提交材料",
    text: "在匿名入口填写事件经过，可附上聊天截图、通知原文或文件说明。联系方式为选填项。",
  },
  {
    icon: "ri-git-branch-line",
    title: "初步归类",
    text: "平台按内部消息、公众事件、身边事或维权线索等主题进行归类，并建立时间线。",
  },
  {
    icon: "ri-search-eye-line",
    title: "交叉核实",
    text: "对存在争议的内容，尽量联系多方说法并列呈现，避免单边叙述造成误读。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    text: "有新的进展或事实更正时，在对应入口同步，状态标注为“已更新”，保留修改记录。",
  },
];

function ProcessSteps() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="mb-3 inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              投稿流程
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
              一条线索从提交到公开，会经历什么
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              平台不替任何一方下结论，只负责把信息整理清楚、归档归类、并持续跟进。每一步都有迹可循，方便你之后回查。
            </p>
          </div>

          <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-8">
            {steps.map((step, index) => (
              <li
                key={step.title}
                className="relative rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="absolute right-4 top-4 font-heading text-2xl font-bold text-background-300">
                  0{index + 1}
                </span>
                <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${step.icon} text-xl`} />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

export default ProcessSteps;